import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IAppRequest } from '@app/app.interface';
import { NotifierService } from '@services/notifier.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileSaverService } from 'ngx-filesaver';
import { Observable } from 'rxjs';
import { AppService } from '../../../app.service';
import { AppHelper } from '../../../core/app.helper';
import {
    IFactorHistoryField,
    IFactorHistoryRecord,
    IFactorHistoryRequestData,
    IFactorHistoryRevisionContext,
    IFactorHistorySidebarData,
} from '../interfaces/factor-row.interface';

@Injectable({
    providedIn: 'root',
})
export class FactorRowHistoryService extends AppService {
    /** Сохранение Blob с освобождением временного URL после запуска скачивания. */
    private readonly fileSaver = inject(FileSaverService);

    className: string = 'FactorRowHistoryService';

    /**
     * URL страницы
     */
    url = '/factor/front_row';

    /**
     * Получение полной истории изменений записи.
     * @param data данные для получения истории
     */
    getAllHistoryData(data: IFactorHistoryRequestData): Observable<IAppRequest<IFactorHistoryRecord[]>> {
        return this.http.post<IAppRequest<IFactorHistoryRecord[]>>(
            this.serverUrl + this.url + '/get_all_history',
            data,
            this._httpOptions,
        );
    }
    /**
     * Получение истории изменений отдельного поля.
     * @param data данные для получения истории
     */
    getHistoryData(data: IFactorHistoryRequestData): Observable<IAppRequest<IFactorHistoryRecord[]>> {
        return this.http.post<IAppRequest<IFactorHistoryRecord[]>>(
            this.serverUrl + this.url + '/get_history',
            data,
            this._httpOptions,
        );
    }

    /**
     * Подготовить данные истории изменения поля для боковой панели.
     * @param item поле
     * @param options контекст записи
     * @param form форма карточки с текущим значением поля
     */
    showRevisionHistory(
        item: IFactorHistoryField,
        options: IFactorHistoryRevisionContext,
        form?: FormGroup,
    ): IFactorHistorySidebarData {
        return {
            data: {
                factor_data_id: options.factorDataId,
                factor_id: item.id,
                language: options.language,
                recordType: typeof options.factorDataId === 'number' ? 'link' : 'main',
                type: item.data_type,
                value: form?.get(String(item.id))?.value?.data ?? null,
                tableData: options.tableData ?? null,
            },
            type: 'one',
        };
    }
    /**
     * Выгрузка истории изменений в Excel
     * @param spinner прелоадер
     * @param notifier сервис всплывающих сообщений
     * @param postData данные для получения истории
     */
    exportChangeHistory(spinner: NgxSpinnerService, notifier: NotifierService, postData: IFactorHistoryRequestData) {
        spinner.show();
        this.downloadService(postData, '/factor/front_row/export_history')
            .toPromise()
            .then((result: HttpResponse<Blob>) => {
                // FileSaver декодирует имя самостоятельно; сохраняем уже декодированные символы, включая %.
                this.fileSaver.save(result.body, encodeURI(AppHelper.getHeaderFileName(result.headers)));
                spinner.hide();
            })
            .catch(() => {
                spinner.hide();
                notifier.notify('error', this.language_dictionary.system_no_connection_with_system);
            });
    }
}
